<template>
  <Modal
    class="tw-translate-y-[-50%] member-details-modal"
    :max-width="DEFAULT_MAX_WIDTH_MODAL"
    :value="formModel"
    :visible="showRef"
    @close="handleCloseModal(true)"
  >
    <ModalHeader
      class="modal-header"
      :title="getUiText('app-settings-team-members-organisation-modal-title-1')"
      @close="handleCloseModal"
    />
    <div class="tw-p-10 modal-member-detail">
      <div class="tw-flex tw-items-center tw-gap-[15px]">
        <span
          class="tw-text-[25px] tw-text-[#211F58] tw-font-[600] tw-leading-none"
          >{{
            getUiText(
              "app-settings-team-members-organisation-modal-sub-title-1",
            )
          }}</span
        >
      </div>
      <NoteInfo
        class="tw-mt-[20px] tw-mb-[25px]"
        @close="() => (notInfoVisible = false)"
      >
        <span
          class="tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-normal tw-leading-[145%]"
          >{{
            getUiText("app-settings-team-members-organisation-modal-note-1")
          }}</span
        >&nbsp;
        <a href="#" class="tw-underline tw-text-[#387DFF] tw-text-[15px]">{{
          getUiText("app-settings-team-members-tip-top-link-text-1")
        }}</a>
      </NoteInfo>
      <BaseForm :enter-event="true" :show="showRef" @on-submit="onSubmit">
        <!-- Field : Name -->
        <BaseInput
          id="name"
          v-model="formModel.name"
          :validation="$v.name"
          :label="getComponentUiText('app-manage-orgs-name-text-1')"
          :placeholder="'Bob Michaels'"
        >
          <div class="input-container email-container tw-flex">
            <div class="input-container tw-grow tw-flex-1">
              <BFormInput
                v-model="formModel.name"
                type="text"
                :placeholder="
                  getComponentUiText(
                    'app-setting-team-member-detail-fullname-placeholder-1',
                  )
                "
                :class="[
                  customClassInputEmail,
                  $v.name.$error ? 'is-invalid' : '',
                ]"
                class="autoFocus"
                @blur="() => $v.name.$touch()"
                @input="updateValueInputFiled"
              />
            </div>
          </div>
        </BaseInput>
        <!-- Field : Email -->
        <BaseInput
          id="email"
          v-model="formModel.email"
          :validation="$v.email"
          :is-focus-slot="focusEmailName"
          :label="getComponentUiText('app-user-profile-form-label-email-1')"
          :placeholder="
            getUiText(
              'app-settings-team-members-organisation-modal-form-placeholder-title',
            )
          "
        >
          <div class="input-container email-container tw-flex">
            <div class="input-container tw-grow tw-flex-1">
              <BFormInput
                v-model="formModel.email"
                type="text"
                :placeholder="
                  getComponentUiText(
                    'app-setting-team-member-detail-username-placeholder-1',
                  )
                "
                :class="[
                  'form-control input-base-form-input',
                  $v.email.$error &&
                  (!focusEmailName ||
                    $v.email.$errors[0].$validator !== 'email')
                    ? 'is-invalid'
                    : '',
                ]"
                :state="$v.email.dirty ? $v.email.$error : null"
                @input="handleInputEmail"
                @blur="
                  () => {
                    $v.email.$touch();
                    focusEmailName = false;
                  }
                "
                @focus="() => (focusEmailName = true)"
              />
            </div>
            <span class="text-container tw-mx-[16px] tw-leading-[56px]">@</span>
            <div class="dropdown-container tw-flex-1 dropdown">
              <BaseDropDown
                :id="'domain'"
                v-model="formModel.domainId"
                :data="domainSelectOptions"
                :validation="$v.domainId"
                :class-name="'gray-dropdown-container tw-h-[58px]'"
                :placeholder="
                  getUiText('app-component-custom-b-dropdown-prompt-email-1')
                "
              />
            </div>
          </div>
        </BaseInput>
        <!-- Field : Title -->
        <BaseInput
          id="title"
          v-model="formModel.title"
          :validation="$v.title"
          :label="
            getComponentUiText('app-component-custom-b-dropdown-label-title-1')
          "
          :placeholder="
            getUiText(
              'app-settings-team-members-organisation-modal-form-placeholder-title',
            )
          "
        />

        <!-- Field : Roles -->
        <BaseInput
          id="roleIds"
          v-model="formModel.roleIds"
          :validation="$v.roleIds"
          :label="
            getComponentUiText('app-component-custom-b-dropdown-label-roles-1')
          "
        >
          <BaseMultiDropDown
            :id="'dropdownIcon'"
            v-model="formModel.roleIds"
            :data="memberRoles"
            :validation="$v.roleIds"
            :class-name="'member-detail-dropdown gray-dropdown-container tw-min-h-[58px] tw-text-[#FFFFFF]'"
            :placeholder="
              getComponentUiText(
                'app-component-custom-b-dropdown-prompt-roles-1',
              )
            "
          />
        </BaseInput>
        <div class="button-container tw-flex tw-justify-end tw-mt-[40px]">
          <b-button
            variant="primary"
            class="button-verify tw-bg-[#387DFF] tw-h-[39px] tw-py-0 tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
            @click="onSubmit"
          >
            <LottieAnimation
              v-if="showLoadingSubmitButton"
              :class="'tw-h-[41px] tw-w-full'"
              :animation-data="ProgressAnimation"
              :auto-play="true"
              :loop="true"
            />

            <span>
              {{
                getUiText(
                  "app-settings-team-members-organisation-modal-invite-button-1",
                )
              }}
            </span>
          </b-button>
        </div>
      </BaseForm>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import store from "../../../store";
import utilities, {
  IsSpecialCharEmailNameValid,
  IsSpecialCharEmailNameValidWhieTyping,
  IsSpecialCharNameValid,
  getComponentUiText,
} from "../../../utils/utilities";
import {
  computed,
  reactive,
  ref,
  watch,
  Ref,
  onBeforeMount,
  onUpdated,
} from "vue";

import Modal from "../../common/modal.vue";
import ModalHeader from "../../common/modalHeader.vue";
import NoteInfo from "../../../components/common/noteInfo.vue";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import {
  getOrgDomains,
  postOrgMemberCreate,
  postOrgDomainVerifyById,
} from "@/services/org";
import { IOrgDetails } from "@/interfaces/orgInterfaces";
import BaseInput from "@/components/common/form/baseInput.vue";
import BaseDropDown from "@/components/common/form/baseDropDown.vue";
import BaseMultiDropDown from "@/components/common/form/baseMultiDropDown.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import BaseForm from "@/components/common/form/baseForm.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import { IModalMessage } from "@/interfaces/common/common";
import { ExceptionTypes, MODAL_NAME } from "@/utils/constants";
import { IOrgRole } from "@/interfaces/org/role";
import { LottieAnimation } from "lottie-web-vue";
import ProgressAnimation from "@/assets/animation/progress_dark.json";
const DEFAULT_MAX_WIDTH_MODAL = 65;

const memberRoles: Ref<IDropDownData[]> = computed(() => {
  const orgRoles: IOrgRole[] = store.state.Org.orgRoles;
  return orgRoles.map((item) => {
    return {
      id: item.roleId,
      name: item.roleName,
    };
  });
});
const domainSelectOptions: Ref<IDropDownData[]> = ref([]);
const cssFieldEmail =
  "form-control input-base-form-input tw-gap-2.5 tw-border tw-text-[#231F20] tw-text-[15px] tw-leading-none tw-pl-[25px] tw-pr-[45px] tw-py-[20px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] tw-bg-[#FFFFFF]";
const CUSTOM_CLASS_INPUT_INVALID = "is-invalid";
const customClassInputEmail = ref(cssFieldEmail);
const showLoadingSubmitButton: Ref<boolean> = ref(false);

const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
});

const emit = defineEmits(["update:show", "add:member"]);

const focusEmailName = ref(false);

const initialForm = {
  name: "",
  email: "",
  domainId: "",
  title: "",
  roles: [],
  roleIds: [],
};
// Form modal and validation.
const formModel = reactive({ ...initialForm });

const rules = {
  name: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    IsSpecialCharNameValid: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-team-members-organisation-modal-name-invalid-error-1",
        ),
      IsSpecialCharNameValid,
    ),
  },
  email: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    specialChar: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-team-members-organisation-modal-email-error-1",
        ),
      IsSpecialCharEmailNameValidWhieTyping,
    ),
    email: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-team-members-organisation-modal-email-error-1",
        ),
      IsSpecialCharEmailNameValid,
    ),
  },
  domainId: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  title: {},
  roles: {},
  roleIds: {},
};

const $v = useVuelidate(rules, formModel);
let showRef = ref(props.show);
let notInfoVisible = ref(true);

const orgDetails: Ref<IOrgDetails> = computed(
  () => store.getters["Org/getOrgDetails"],
);
const getFormData = async () => {
  if (orgDetails.value.id) {
    try {
      const domainResponse = await getOrgDomains(orgDetails.value.id);
      if (
        domainResponse?.data?.data &&
        Array.isArray(domainResponse.data.data?.domains)
      ) {
        if (domainResponse?.data?.data.domains.length === 1) {
          formModel.domainId = domainResponse?.data?.data.domains[0].domainId;
        }
        domainSelectOptions.value = domainResponse.data.data?.domains
          .filter((item) => !!item.isVerifiedEmail)
          .map((item) => {
            return {
              id: item.domainId,
              name: item.domain,
              domain: item.domain,
            };
          });
      }
    } catch (error: any) {
      if (error && error.data) {
        showErrorAPI(error, Org.getDomains);
      }
    }
  }
};

const isDisableCheckName: Ref<boolean> = ref(true);

const handleUpdateCssInput = async () => {
  await $v.value.name.$validate();
  if (formModel.name && utilities.IsSpecialCharNameValid(formModel.name)) {
    customClassInputEmail.value = cssFieldEmail;
  } else {
    customClassInputEmail.value = `${cssFieldEmail} ${CUSTOM_CLASS_INPUT_INVALID}`;
  }
};

const updateValueInputFiled = () => {
  if (isDisableCheckName.value) return;
  handleUpdateCssInput();
};

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) initial();
    else clearWatchAndListener();
  },
);

watch(orgDetails, getFormData, { deep: true });

onBeforeMount(() => {
  getFormData();
});

onUpdated(() => {
  getFormData();
});

const initial = () => {
  notInfoVisible.value = true;
  customClassInputEmail.value = cssFieldEmail;
  listeningEvent();
};

const listeningEvent = () => {
  EventEmitter.on(EmitterEvents.EVENT_KEYBOARD_ENTER, () => onSubmit());
};

const clearWatchAndListener = () => {
  EventEmitter.off(EmitterEvents.EVENT_KEYBOARD_ENTER);
};

const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);
const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const successMessage = getUiText(
  "app-settings-team-members-organisation-modal-add-org-member-success-1",
);

const secretRequiredPasswordReset = computed(
  () => store.state.Org.currentOrgSecretRequired?.secretRequiredPasswordReset,
);

const onSubmit = async () => {
  await $v.value.$validate();
  isDisableCheckName.value = false;
  handleUpdateCssInput();
  if ($v.value.$invalid) return;

  showLoadingSubmitButton.value = true;

  try {
    const dataCreate = {
      ...(utilities.getFirstAndLastNameFromName(formModel.name) as {
        firstName: string;
        lastName: string;
      }),
      email: `${formModel.email}@${getDomainFromId()}`,
      title: formModel.title,
      requireMFA: false,
      ...(formModel.roleIds.length
        ? {
            roleIds: formModel.roleIds.map(
              (item: number | string) => `${item}`,
            ),
          }
        : {}),
    };
    const formResponse: any = await postOrgMemberCreate(dataCreate);
    if (formResponse.data?.data) {
      onShowToast(successMessage, ToastVariant.SUCCESS);
      const data = {
        ...(utilities.getFirstAndLastNameFromName(formModel.name) as {
          firstName: string;
          lastName: string;
        }),
        secretKey: formResponse.data?.data.secret,
      };
      if (secretRequiredPasswordReset.value) {
        EventEmitter.emit(EmitterEvents.ORG_MEMBER_CREATED, data);
      }
      emit("add:member");
      handleCloseModal();
    }
  } catch (error: any) {
    if (error && error.data) {
      if (error.data.error.type === ExceptionTypes.EmailDomainNotVerified) {
        showVerifyModal(
          getDomainFromId(),
          formModel.domainId,
          `${formModel.email}@${getDomainFromId()}`,
        );
      } else {
        showErrorAPI(error, Org.createMember);
      }
    }
  } finally {
    showLoadingSubmitButton.value = false;
  }
};

const showVerifyModal = (domain, domainId, email) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-settings-organisation-member-domain-unverify-modal-title-1",
      ),
      description: getComponentUiText(
        "app-settings-organisation-member-domain-unverify-modal-description-1",
        false,
        { domain },
      ),
      buttonText: getComponentUiText(
        "app-settings-organisation-member-domain-unverify-modal-button-1",
      ),
      buttonRed: false,
      hiddenHelp: false,
    },
    events: {
      "update:data": async () => {
        try {
          handleCloseModal();
          const formResponse: any = await postOrgDomainVerifyById(
            domainId,
            email,
          );
          if (formResponse.data?.data) {
            onShowToast(
              getUiText(
                "app-settings-organisation-member-domain-unverify-modal-message-1",
              ),
              ToastVariant.SUCCESS,
            );
          }
        } catch (error: any) {
          if (error && error.data) {
            showErrorAPI(error, Org.orgDomainVerify);
          }
        }
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const onShowToast = (messageError: string, variant: ToastVariant) => {
  const emitData: IToastMessage = { variant, message: messageError };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const getDomainFromId = () => {
  const domain = domainSelectOptions.value.find(
    (domain) => domain.id === formModel.domainId,
  );
  return domain ? domain.domain : "";
};
const clearData = () => {
  for (const key in formModel) {
    if (Array.isArray(formModel[key])) {
      formModel[key].splice(0); // Clear the array content while maintaining reference
    } else {
      formModel[key] = initialForm[key];
    }
  }
  $v.value.$reset();
};

const handleInputEmail = (val: string) => {
  if (val.trim() === "") $v.value.email.$reset();
  else {
    $v.value.email.$touch();
    $v.value.email.$model = val;
  }
};

const handleCloseModal = (fromModal = false) => {
  if (
    (formModel.name ||
      formModel.email ||
      formModel.title ||
      formModel.roles.length ||
      formModel.roleIds.length ||
      formModel.domainId) &&
    fromModal
  )
    return;
  clearData();
  showRef.value = false;
  emit("update:show", showRef.value);
};
</script>

<style lang="scss">
.member-details-modal {
  .button-verify.btn.btn-primary[disabled] {
    background-color: #dbdbdb;
    color: #b7b7b7;
    border-color: #dbdbdb;
  }

  .copy-info-container {
    max-width: 70%;
  }

  .text-copy-container {
    width: calc(100% - 22px);
  }

  .button-delete {
    line-height: 100%;
    background-color: #f7553c;
    border-color: #f7553c;
  }

  .button-verify-later {
    line-height: 100%;
    border: 2px solid #387dff;
    background-color: #ffffff;
    color: #387dff;
  }

  .button-verify {
    line-height: 100%;
    background-color: #387dff;
    border-color: #387dff;
  }

  .status-domain {
    padding: 3px 5px;
    font-family: Poppins;
    font-size: 11px;
    font-weight: 500;
    line-height: 130%;
    border-radius: 4px;

    background: var(--ui-green-soft, #d9ede2);
    color: #01893d;
  }
}

@media (min-height: 768px) {
  .member-details-modal {
    .modal-main {
      overflow: visible;

      .dropdown-menu {
        max-height: 169px;
        overflow: auto;
      }
    }
  }
}

@media (max-width: 991px) {
  .member-details-modal {
    .copy-info-container {
      max-width: fit-content;
    }
  }
}

@media (max-width: 420px) {
  .member-details-modal {
    .button-container-left {
      margin-top: 10px;
    }

    .field-container {
      flex-direction: column;
      align-items: flex-start;
    }

    .input-container {
      width: 100%;
    }

    .label-container {
      height: unset !important;
      width: unset !important;
      line-height: normal !important;
    }

    .dropdown-container {
      margin-top: 7px !important;
    }
  }
}

@media (max-width: 768px) {
  .member-details-modal {
    .email-container {
      display: grid;
      grid-template-columns: auto 48px;
      grid-template-areas:
        "input text"
        "dropdown dropdown";

      .input-container {
        grid-area: input;
      }

      .text-container {
        grid-area: text;
      }

      .dropdown-container {
        margin-top: 20px;
        grid-area: dropdown;
      }
    }
  }
}
</style>
